import QRCode from "qrcode";

export function renderQrSvg(value) {
  return QRCode.toString(value, {
    type: "svg",
    errorCorrectionLevel: "M",
    margin: 0,
    color: { dark: "#030712", light: "#ffffff" },
  });
}

export function verificacionUrl(folio) {
  const origin = typeof window !== "undefined" ? window.location.origin : "";
  return `${origin}/verificar/${folio}`;
}

/** Payload de muestra: no usa el dominio interno. */
export function qrMuestraValue(folio) {
  return `BREMAR certificado de muestra\nFolio: ${folio || "MUESTRA"}`;
}

export const VERIFICACION_MUESTRA_PATH = "/verificar/muestra";
